import React, { FC, memo } from 'react'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Person } from '@ucheba/ui/components/Person/desktop'
import { IEventsId } from '@ucheba/store/events/id/types'
import AvatarDefault from '../../../../../../public/static/img/avatar-default.jpg'

const EventsLeading: FC<{ speakers: IEventsId['speakers'] }> = (props) => {
  const { speakers } = props

  return (
    <>
      <Grid spacing='small'>
        {speakers &&
          speakers.map(({ id, fullName, description, avatarThumbnailUrl }) => (
            <GridCol uxs={12} key={id} width='50%'>
              <Person
                imgSize='medium'
                name={fullName}
                hint={description}
                imgUrl={
                  avatarThumbnailUrl
                    ? `https://www.ucheba.ru${avatarThumbnailUrl}`
                    : AvatarDefault
                }
              />
            </GridCol>
          ))}
      </Grid>

      <Spacing spacing='xlarge' />
    </>
  )
}

export default memo(EventsLeading)
